/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */

export type BulkReprocessRunDtoStatus = typeof BulkReprocessRunDtoStatus[keyof typeof BulkReprocessRunDtoStatus];


export const BulkReprocessRunDtoStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
} as const;
